import { useContext, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { DynamicQuestionsContext } from 'chameleon/packages/blue-book-player/state/DynamicQuestionContext';

const useListenToDynamicQuestions = (learnosityApp, callback) => {
  const { state } = useContext(DynamicQuestionsContext) || {};
  const { currentQuestionKeys } = state || {};

  useEffect(() => {
    if (!isEmpty(currentQuestionKeys)) {
      const allQuestionAPis = learnosityApp.questions();
      const questionApis = currentQuestionKeys.map(
        (questionKey) => allQuestionAPis[questionKey],
      );
      callback(questionApis);
    }
  }, [currentQuestionKeys, learnosityApp]);

  return null;
};

export default useListenToDynamicQuestions;
